import React, {useState} from 'react';
import BackgroundPhoto from '../BackgroundPhoto';
import { Button } from 'react-bootstrap';
import YotiScreen from '../YotiScreen';

export default function YotiUboComponent({url, completed = false}) {

  const [showYoti, setShowYoti] = useState(false);

  if(completed) return (
    <BackgroundPhoto>
      <h5>Thank you for completing this process</h5>
    </BackgroundPhoto>
  );

  if(showYoti) return (
    <div style={{width:"100vw", height:"90vh",}}>
      <YotiScreen url={url}/>
    </div>
  );

  return (
    <BackgroundPhoto>
      <h5>Welcome to the KYC process</h5>
      <Button variant="dark" style={{/*marginTop: 10, fontWeight: "bold"*/}} onClick={() => setShowYoti(true)}>Click to start</Button>
    </BackgroundPhoto>
  );
}